import React, { useEffect, useMemo, useState } from "react";
import AnimatedMainContainer from "../../components/AnimatedMainContainer";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Card,
  CardContainer,
  CardHeader,
  CodeCard,
  Container,
  Divider,
  FooterCreatePage,
  FooterLink,
  Header,
  NameCard,
  Title,
  TitleContainer,
  YearCard,
} from "./style";
import { useDispatch, useSelector } from "react-redux";

import SelectFilter from "../InformaAcademy/Analytics/components/SelectFilter";
import { getEventList } from "../../redux/modules/analytics/actions";
import { debounce } from "lodash";
import SearchInput from "../InformaAcademy/components/SearchInput";
import { getEventsInfo } from "../../redux/modules/event/actions";
import { resetAdminBannersState } from "../../redux/modules/informaAcademy/actions";
import EmptyFilter from "./components/empty";

const ManageHomepageBanner = () => {
  const intl = useIntl();

  const [inputValue, setInputValue] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");

  const dispatch = useDispatch();
  const { years, eventsInfo, isLoadingInfo } = useSelector(
    (state) => state.analytics
  );
  const { events } = useSelector((state) => state.event);

  useEffect(() => {
    dispatch(getEventsInfo());
    dispatch(getEventList());
    dispatch(resetAdminBannersState());
  }, [dispatch]);

  const eventsFilterMap = useMemo(() => {
    if (inputValue) {
      const caseInsensitive = inputValue.toLowerCase();
      return eventsInfo.filter(
        (event) =>
          event.eventEditionCode.toLowerCase().includes(caseInsensitive) ||
          event.name.toLowerCase().includes(caseInsensitive)
      );
    }

    if (selectedEvent && selectedYear) {
      return eventsInfo.filter(
        (event) =>
          event.year === selectedYear &&
          event.name.toLowerCase().includes(selectedEvent.toLowerCase())
      );
    }

    if (selectedYear) {
      return eventsInfo.filter((event) => event.year === selectedYear);
    }

    if (selectedEvent) {
      return eventsInfo.filter((event) =>
        event.name.toLowerCase().includes(selectedEvent.toLowerCase())
      );
    }

    return eventsInfo;
  }, [inputValue, selectedEvent, selectedYear, eventsInfo]);

  const debouncedSearch = debounce((value) => {
    setInputValue(value);
  }, 1);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  };

  const resetFilters = () => {
    setSelectedEvent("");
    setSelectedYear("");
    setInputValue("");
  };

  return (
    <AnimatedMainContainer
      breadcrumb={intl.formatMessage({
        id: "breadcrumb.manage-homepage-banner",
      })}
    >
      <Container>
        <Header>
          <TitleContainer>
            <Title>
              <FormattedMessage id="active_events" /> ({eventsFilterMap.length})
            </Title>
            <SelectFilter
              label={"year"}
              options={years}
              setValue={setSelectedYear}
              value={selectedYear}
              fit
            />
            <SelectFilter
              label={"event"}
              options={events.map((event) => ({
                label: event.label,
                value: event.label,
              }))}
              setValue={setSelectedEvent}
              value={selectedEvent}
              fit
            />
          </TitleContainer>
          <SearchInput value={inputValue} onChange={handleSearchChange} />
        </Header>

        {!isLoadingInfo && eventsFilterMap.length > 0 && (
          <CardContainer>
            {eventsFilterMap.map((event) => {
              return (
                <Card key={event.id}>
                  <CardHeader>
                    <CodeCard>{event.eventEditionCode}</CodeCard>
                    <NameCard title={event.name}>{event.name}</NameCard>
                    <YearCard>{event.year}</YearCard>
                  </CardHeader>

                  <Divider />

                  {event.homePageId && (
                    <FooterLink
                      to={`/admin/informa-academy/manage-homepage/edit/${event.id}`}
                    >
                      <EyeIcon />
                      {intl.formatMessage({
                        id: "preview_homepage_event_list",
                      })}
                    </FooterLink>
                  )}

                  {!event.homePageId && (
                    <FooterCreatePage
                      to={`/admin/informa-academy/manage-homepage/create/${event.id}`}
                    >
                      <PlusIcon />
                      {intl.formatMessage({
                        id: "create_homepage_event_list",
                      })}
                    </FooterCreatePage>
                  )}
                </Card>
              );
            })}
          </CardContainer>
        )}

        {!isLoadingInfo && eventsFilterMap.length === 0 && (
          <EmptyFilter resetFilters={resetFilters} />
        )}
      </Container>
    </AnimatedMainContainer>
  );
};

export default ManageHomepageBanner;

function EyeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="11"
      fill="none"
      viewBox="0 0 17 11"
    >
      <path
        fill="#11A7D9"
        stroke="#11A7D9"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.5 10c4.142 0 7.5-4.5 7.5-4.5S12.642 1 8.5 1 1 5.5 1 5.5 4.358 10 8.5 10Z"
      />
      <path
        fill="#11A7D9"
        stroke="#FFF4F0"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.5 7.375a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        stroke="#024"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m8.02 3.833-.012 9.333M3.332 8.5h9.333"
      ></path>
    </svg>
  );
}
